// import { SearchOrderBy, SearchOrderByHelper } from './searchOrderBy';
import { SearchIncrementType } from './searchIncrementType';
import { ListType } from './filterTop';
import { SearchParams } from './searchParams';
import * as _ from 'lodash';

export enum SearchSettingsStatus {
    Initialized,
    Loaded,
    Loading
}

export class SearchSettings {
    loaded = false;
    email: '';
    language: 'es'; // TODO global-language
    confirmacionPedido: false;

    confirmacionEmail: false;
    copiaPDF: false;

    numRuedas: 2;

    numArticulos: 50;
    predetConStock: false;
    stock_minimo = 2;

    mostrarImagenes: false;
    segundaBusqueda: false;

    requestEmail: false;
    email_name: '';
    email_surname: '';
    incremento_cantidad = 0;

    incremento_tipo: SearchIncrementType = SearchIncrementType.Value;

    address = null;
    withStock: false;

    inmediateDelivery: false;

    ordenBusqueda = 1;
    formaPago: '';
    confirmarPorMovil: false;
    ocultarIncremento: false;

    mostrarPVR: boolean;

    mostrarCoste: boolean = true;

    tipoResultadoBusqueda: string;
    mostrarCantidadBusqueda: boolean;
    equivalenciasDefault: boolean;

    confirmarPedidoServido: boolean;
    filtroICCVSuperiores: boolean;
    condicionesAceptadas: boolean = false;

    isGiftAddress: boolean = false;
    defaultGiftAddress: number = -1;
}

export class SearchSettingsHelper {
    static transformFromApi(apiData: Object, environment: any): SearchSettings {
        const settings = new SearchSettings();
        settings.loaded = true;
        settings.email = apiData['CO_EMAILUSUARIO'] ? apiData['CO_EMAILUSUARIO'] : '';
        settings.confirmacionEmail = apiData['CO_CONFIRMARPOREMAIL'] ? apiData['CO_CONFIRMARPOREMAIL'] : false;
        settings.numRuedas = apiData['CO_NUMERORUEDAS'] ? apiData['CO_NUMERORUEDAS'] : 2;
        settings.numArticulos = apiData['CO_NUMEROREGISTROS'] ? apiData['CO_NUMEROREGISTROS'] : 50;
        settings.predetConStock = apiData['CO_CONSTOCK'] ? apiData['CO_CONSTOCK'] : false;
        settings.requestEmail = apiData['CO_SOLICITAREMAIL'] ? apiData['CO_SOLICITAREMAIL'] : false;
        settings.email_name = apiData['CO_NOMBREEMAIL'] ? apiData['CO_NOMBREEMAIL'] : '';
        settings.email_surname = apiData['CO_APELLIDOSEMAIL'] ? apiData['CO_APELLIDOSEMAIL'] : '';
        settings.incremento_cantidad = apiData['CO_INCREMENTO_CANTIDAD'] ? apiData['CO_INCREMENTO_CANTIDAD'] : 0;
        settings.incremento_tipo =
            apiData['CO_INCREMENTO_TIPO'] === '€' ? SearchIncrementType.Value : SearchIncrementType.Percentage;
        settings.address = apiData['CO_DIRECCIONDEFECTO'] ? apiData['CO_DIRECCIONDEFECTO'] : 0;
        settings.inmediateDelivery = apiData['CO_INMEDIATE'] ? apiData['CO_INMEDIATE'] : 0;
        settings.withStock = settings.predetConStock;
        settings.ordenBusqueda = apiData['CO_ORDEN_BUSQUEDA'] ? apiData['CO_ORDEN_BUSQUEDA'] : 1;
        settings.formaPago = apiData['CO_FORMA_PAGO'] ? apiData['CO_FORMA_PAGO'] : false;
        settings.confirmarPorMovil = apiData['CO_CONFIRMARPORMOVIL'] ? apiData['CO_CONFIRMARPORMOVIL'] : false;
        settings.ocultarIncremento = apiData['CO_OCULTAR_INCREMENTO'] ? apiData['CO_OCULTAR_INCREMENTO'] : false;
        settings.mostrarPVR = apiData['CO_MOSTRARPVR'] ? apiData['CO_MOSTRARPVR'] : false;

        settings.tipoResultadoBusqueda = apiData['CO_TIPO_RESULTADO_BUSQUEDA']
            ? apiData['CO_TIPO_RESULTADO_BUSQUEDA']
            : 'BASICO';
        settings.mostrarCantidadBusqueda = apiData['CO_MOSTRAR_CANTIDAD_BUSQUEDA']
            ? apiData['CO_MOSTRAR_CANTIDAD_BUSQUEDA']
            : false;
        settings.equivalenciasDefault = apiData['CO_EQUIVALENCIAS_PREDETERMINADO']
            ? apiData['CO_EQUIVALENCIAS_PREDETERMINADO']
            : false;

        settings.confirmarPedidoServido = apiData['CO_CONFIRMAR_PEDIDOSERVIDO']
            ? apiData['CO_CONFIRMAR_PEDIDOSERVIDO']
            : false;
        settings.filtroICCVSuperiores = apiData['CO_FILTRO_ICCVSUPERIORES']
            ? apiData['CO_FILTRO_ICCVSUPERIORES']
            : false;

        settings.condicionesAceptadas = apiData['CO_CONDICIONESACEPTADAS'] == 1 ? true : false;

        // settings.language = apiData['CO_IDIOMA']; // TODO @Fabiano @Dani de momento se ha dejado así -> no hay environment.acceptedLanguages
        if (apiData['CO_IDIOMA'] && apiData['CO_IDIOMA'].indexOf('_') >= 0) {
            const langParts = apiData['CO_IDIOMA'].split('_');
            settings.language = langParts[0];
        } else {
            settings.language = apiData['CO_IDIOMA'];
        }

        settings.isGiftAddress = false;
        settings.defaultGiftAddress =
            typeof apiData['CO_DIRECCIONDEFECTO_REGALO'] === 'number' ? apiData['CO_DIRECCIONDEFECTO_REGALO'] : -1;

        for (const i in environment.acceptedLanguages) {
            if (environment.acceptedLanguages[i] === settings.language) {
                environment.currentLang = settings.language;
            }
        }
        return settings;
    }

    static fromJSON(json: string, clienteCodigo): SearchSettings {
        const params = JSON.parse(json);

        const settings = JSON.parse(sessionStorage.getItem(clienteCodigo + 'SearchSettings'));

        // const settings = new SearchSettings();

        settings.numRuedas = params['numRuedas'];
        settings.equivalenciasDefault = params['equivalences'];
        settings.predetConStock = params['stock'];
        settings.stock_minimo = params['stock_minimo'];
        settings.ordenBusqueda = params['ordenBusqueda'];
        settings.mostrarCoste = params['coste'];
        settings.mostrarPVR = params['pvr'];
        settings.incremento_cantidad = params['increment'].value;
        settings.incremento_tipo = params['increment'].type;
        settings.tipoResultadoBusqueda = params['currentListType'] === ListType.small ? 'BASICO' : 'AVANZADO';

        // TODO: saber porque este parametro desaparece de la interfaz y llega aqui undefined
        settings.mostrarCantidadBusqueda = settings['mostrarCantidadBusqueda']
            ? settings['mostrarCantidadBusqueda']
            : 1;
        // settings.loaded = params['loaded'];
        // settings.email = params['email'];
        // settings.language = params['language'];
        // settings.confirmacionPedido = params['confirmacionPedido'];
        // settings.confirmacionEmail = params['confirmacionEmail'];

        // settings.copiaPDF = params['copiaPDF'];
        // settings.numArticulos = params['numArticulos'];

        // settings.numRuedas = params['numRuedas'];
        // settings.predetConStock = params['predetConStock'];
        // settings.predetConStock_list = params['predetConStock_list'];
        // settings.mostrarImagenes = params['mostrarImagenes'];
        // settings.segundaBusqueda = params['segundaBusqueda'];
        // settings.requestEmail = params['requestEmail'];

        // settings.email_name = params['email_name'];
        // settings.email_surname = params['email_surname'];
        // settings.incremento_cantidad = params['incremento_cantidad'];
        // settings.incremento_tipo = params['incremento_tipo'];
        // settings.address = params['address'];
        // settings.withStock = params['withStock'];
        // settings.inmediateDelivery = params['inmediateDelivery'];
        // settings.formaPago = params['formaPago'];
        // settings.confirmarPorMovil = params['confirmarPorMovil'];

        // settings.ocultarIncremento = params['ocultarIncremento'];
        // settings.mostrarPVR = params['mostrarPVR'];
        // settings.equivalenciasDefault = params['equivalenciasDefault'];
        // settings.confirmarPedidoServido = params['confirmarPedidoServido'];
        // settings.filtroICCVSuperiores = params['filtroICCVSuperiores'];

        return settings;
    }

    static fromSearchParamsField(settingsOrg: SearchSettings, field: string, value: any): SearchSettings {
        const settings = _.cloneDeep(settingsOrg);
        settings[field] = value;

        return settings;
    }

    static fromSearchParams(settingsOrg: SearchSettings, searchParams: SearchParams): SearchSettings {
        // const params = JSON.parse(json);

        const settings = _.cloneDeep(settingsOrg);

        // const settings = new SearchSettings();

        settings.numRuedas = searchParams['numRuedas'];
        settings.equivalenciasDefault = searchParams['equivalences'];
        settings.filtroICCVSuperiores = searchParams['iccvsuperiores'];
        settings.predetConStock = searchParams['stock'];
        settings.stock_minimo = searchParams['stock_minimo'];
        settings.ordenBusqueda = searchParams['ordenBusqueda'];
        settings.mostrarCoste = searchParams['coste'];
        settings.mostrarPVR = searchParams['pvr'];
        settings.incremento_cantidad = searchParams['increment'].value;
        settings.incremento_tipo = searchParams['increment'].type;
        settings.tipoResultadoBusqueda = searchParams['currentListType'] === ListType.small ? 'BASICO' : 'AVANZADO';

        // TODO: saber porque este parametro desaparece de la interfaz y llega aqui undefined
        settings.mostrarCantidadBusqueda = searchParams['mostrarCantidadBusqueda']
            ? searchParams['mostrarCantidadBusqueda']
            : 1;
        // settings.loaded = params['loaded'];
        // settings.email = params['email'];
        // settings.language = params['language'];
        // settings.confirmacionPedido = params['confirmacionPedido'];
        // settings.confirmacionEmail = params['confirmacionEmail'];

        // settings.copiaPDF = params['copiaPDF'];
        // settings.numArticulos = params['numArticulos'];

        // settings.numRuedas = params['numRuedas'];
        // settings.predetConStock = params['predetConStock'];
        // settings.predetConStock_list = params['predetConStock_list'];
        // settings.mostrarImagenes = params['mostrarImagenes'];
        // settings.segundaBusqueda = params['segundaBusqueda'];
        // settings.requestEmail = params['requestEmail'];

        // settings.email_name = params['email_name'];
        // settings.email_surname = params['email_surname'];
        // settings.incremento_cantidad = params['incremento_cantidad'];
        // settings.incremento_tipo = params['incremento_tipo'];
        // settings.address = params['address'];
        // settings.withStock = params['withStock'];
        // settings.inmediateDelivery = params['inmediateDelivery'];
        // settings.formaPago = params['formaPago'];
        // settings.confirmarPorMovil = params['confirmarPorMovil'];

        // settings.ocultarIncremento = params['ocultarIncremento'];
        // settings.mostrarPVR = params['mostrarPVR'];
        // settings.equivalenciasDefault = params['equivalenciasDefault'];
        // settings.confirmarPedidoServido = params['confirmarPedidoServido'];
        // settings.filtroICCVSuperiores = params['filtroICCVSuperiores'];

        return settings;
    }
}
